/**
 * Google Services Configuration
 *
 * IMPORTANT: This file contains placeholders for API keys and tokens.
 * Replace the placeholder values with your actual credentials.
 *
 * SECURITY NOTE: Never commit real API keys to version control.
 * Use environment variables in production.
 */

const googleConfig = {
  /**
   * Google reCAPTCHA v3 Configuration
   * Get your site key from: https://www.google.com/recaptcha/admin
   *
   * Setup Instructions:
   * 1. Go to https://www.google.com/recaptcha/admin
   * 2. Register a new site with reCAPTCHA v3
   * 3. Add your domain (e.g., loga.hr)
   * 4. Copy the "Site Key" and paste it below
   * 5. Save the "Secret Key" for backend verification
   */
  recaptcha: {
    siteKey: '6LdEH_orAAAAACJbCh4vNR30c_BUBWRKax8kyx_I', // reCAPTCHA v3 Site Key
    // The secret key should be stored on your backend server, NOT here
    // Example: 6Lc... (Site Key starts with 6L)
  },

  /**
   * Google Analytics 4 (GA4) Configuration
   * Get your Measurement ID from: https://analytics.google.com
   *
   * Setup Instructions:
   * 1. Go to https://analytics.google.com
   * 2. Create a new GA4 property or select existing
   * 3. Go to Admin > Data Streams
   * 4. Click on your web stream
   * 5. Copy the "Measurement ID" (starts with G-)
   * 6. Paste it below
   */
  analytics: {
    measurementId: 'G-389VTK7YQL', // Replace with your GA4 Measurement ID
    // Example: G-ABC123DEF4
  },

  /**
   * Google Tag Manager (Optional)
   * If you want to use GTM instead of direct GA4 implementation
   * Get your GTM ID from: https://tagmanager.google.com
   */
  tagManager: {
    containerId: 'GTM-KBNGQ29M', // Replace with your GTM Container ID (optional)
    // Example: GTM-ABC1234
  },
};

/**
 * Validation function to check if config is set up
 * Use this in development to ensure all keys are configured
 */
export const validateGoogleConfig = () => {
  const warnings = [];

  if (googleConfig.recaptcha.siteKey.includes('YOUR_')) {
    warnings.push('⚠️  reCAPTCHA Site Key not configured');
  }

  if (googleConfig.analytics.measurementId.includes('X')) {
    warnings.push('⚠️  Google Analytics Measurement ID not configured');
  }


  if (warnings.length > 0) {
    console.warn('Google Services Configuration Warnings:');
    warnings.forEach(warning => console.warn(warning));
    console.warn('📝 Edit src/config/google.config.js to add your credentials');
  }

  return warnings.length === 0;
};

export default googleConfig;